import script from "./BenefitCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BenefitCard.vue?vue&type=script&setup=true&lang=js"

import "./BenefitCard.vue?vue&type=style&index=0&id=472915d5&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-472915d5"]])

export default __exports__